import React, { useEffect, useState } from 'react';
import { TextInput, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../MyAppText';
import { translate } from '../../../services/translate';

interface Props {
    label: string;
    fromValue: number | null;
    toValue: number | null;
    onFromChange: (value: number | null) => void;
    onToChange: (value: number | null) => void;
    maxValue?: number;
    minValue?: number;
    disabled?: boolean;
    required?: boolean;
}

export default function FilterNumericRange({ label, fromValue, onFromChange, toValue, onToChange, required, disabled }: Props) {
    const { styles, theme } = useStyles(stylesheet);
    const [isInvalid, setIsInvalid] = useState(false);

    useEffect(() => {

        if (toValue === null || fromValue === null) {
            return setIsInvalid(false);
        }

        if (toValue < fromValue) {
            return setIsInvalid(true);
        }

        setIsInvalid(false);
    }, [fromValue, toValue]);

    return (
        <View style={styles.inputContainer}>
            <View style={{ flexDirection: 'row', gap: 3 }}>
                <MyAppText style={styles.filterText}>
                    {label}
                </MyAppText>
                {required ?
                    <MyAppText style={{ color: theme.colors.errors['300'] }}>(*)</MyAppText>
                    : null}
            </View>
            <View style={[{ flexDirection: 'row' }]}>

                <TextInput
                    keyboardType='number-pad'
                    editable={!disabled}
                    value={fromValue !== null ? String(fromValue) : ''}
                    onChangeText={(value) => {
                        const onlyNumbers = value.replace(/[^0-9]/g, '');
                        const parsed = onlyNumbers.trim() === '' ? null : Number(onlyNumbers);
                        onFromChange(parsed);
                    }}
                    inputMode="numeric"
                    placeholder={translate('minimum')}
                    style={[styles.input, styles.inputLeft, {
                        color: fromValue === null ? theme.colors.placeholder : theme.colors.textColor
                    }, disabled ? styles.disabled : (isInvalid ? styles.invalid : null), {}]}
                />
                <MyAppText style={styles.inputAttach(isInvalid)}>{translate('to')}</MyAppText>
                <TextInput
                    keyboardType='number-pad'
                    editable={!disabled}
                    value={toValue !== null ? String(toValue) : ''}
                    onChangeText={(value) => {
                        const onlyNumbers = value.replace(/[^0-9]/g, '');
                        const parsed = onlyNumbers.trim() === '' ? null : Number(onlyNumbers);
                        onToChange(parsed);
                    }}
                    inputMode="numeric"
                    placeholder={translate('maximumMale')}
                    style={[styles.input, styles.inputRight, {
                        color: toValue === null ? theme.colors.placeholder : theme.colors.textColor
                    }, disabled ? styles.disabled : (isInvalid ? styles.invalid : null), {}]}
                />

            </View>
            {isInvalid ? <MyAppText style={styles.error}>{translate('theValueFromLeftCantBeGreaterThanTheRightValue')}</MyAppText> : null}

        </View >
    );
}

const stylesheet = createStyleSheet(theme => ({
    inputContainer: {
        minWidth: 200,
    },

    error: {
        color: theme.colors.errors['300'],
        fontSize: 10
    },

    inputAttach: (isInvalid: boolean) => ({
        color: isInvalid ? '#FFFFFF' : theme.colors.textColor,
        fontSize: 13,
        backgroundColor: isInvalid ? theme.colors.errors['500'] : theme.colors.container.border,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderRightWidth: 1,
        borderColor: isInvalid ? theme.colors.errors['500'] : theme.colors.container.border,
        padding: 10,
    }),

    invalid: {
        borderColor: theme.colors.errors['500'],
    },

    input: {
        fontSize: 16,
        fontFamily: 'Open Sans',
        backgroundColor: theme.colors.field.background,
        borderColor: theme.colors.field.border,
        borderWidth: 1,
        padding: 10,
        width: 100,
    },

    inputLeft: {
        borderTopStartRadius: 4,
        borderBottomStartRadius: 4,
    },

    inputRight: {
        borderTopEndRadius: 4,
        borderBottomEndRadius: 4,
    },

    filterText: {
        color: theme.colors.labelColor,
        fontSize: 16,
        height: 25,
    },
    disabled: {
        backgroundColor: theme.colors.field.disabledBackground,
    },
}));
